// extracted by mini-css-extract-plugin
export var arrow = "page-navigation-module--arrow--b8c87";
export var currentPage = "page-navigation-module--currentPage--29c2d";
export var invisible = "page-navigation-module--invisible--860d9";
export var left = "page-navigation-module--left--d141f";
export var next = "page-navigation-module--next--1fd5a";
export var noUnderline = "page-navigation-module--noUnderline--c2108";
export var num = "page-navigation-module--num--b9e16";
export var pageNav = "page-navigation-module--pageNav--06643";
export var pageNum = "page-navigation-module--pageNum--669c9";
export var prev = "page-navigation-module--prev--7bc76";
export var right = "page-navigation-module--right--9b0f8";